<template>
  <section class="page-pc">
    <header class="header">
      <h1 class="logo-text">Super File Manager</h1>
      <!-- <section class="name">File Magic</section> -->
      <div class="nav">
        <a class="mail" href="mailto:charaleong@gmail.com">SUPPORT</a>
        <a
          class="privacy"
          target="_blank"
          href="https://sites.google.com/view/superfilemanagerprivacypolicy?usp=sharing"
          >Privacy Policy</a
        >
        <a
          class="terms"
          target="_blank"
          href="https://docs.google.com/document/d/1Bu2zpFDB_TQMnfH6U_MWeWgf14DE1mDA3U70K4mG-rA/edit?usp=sharing"
          >User Agreement</a
        >
      </div>
    </header>
    <div class="main">
      <img class="logo" src="@/assets/images/sfm-logo.png" />
      <p class="text">Super File Manager</p>
      <!-- <p class="desc">Simple file manager & explorer, easily searching your files, folders and doc.</p> -->
      <div class="downloads">
        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.file.manager.explorer.android">
          <img class="googlePlay" src="@/assets/images/google-play.png" alt />
        </a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'page-pc',
  props: ['app'],
  beforeCreate () {
    const { $isServer } = this
    if ($isServer) return
    // eslint-disable-next-line no-new-func
    const fn = new Function(
      `(function(doc,win){var docEl=doc.documentElement;var resizeEvt="orientationchange" in window?"orientationchange":"resize";var recalc=function(){var clientWidth=docEl.clientWidth;if(!clientWidth){return}if(clientWidth>=3840 || clientWidth < 1280){docEl.style.fontSize="100px"}else{docEl.style.fontSize=100*(clientWidth/1280)+"px"}};if(!doc.addEventListener){return}win.addEventListener(resizeEvt,recalc,false);recalc()})(document,window);`
    )
    fn()
  },
  computed: {
    slogen () {
      return this.app
        ? 'Bravo Booster Faster Than Ever'
        : 'Professional monitor of mobile virus, All-in-one security master of your device'
    },
    logoText () {
      return this.app ? 'Bravo Booster' : 'Bravo Security'
    },
    appName () {
      return this.app ? 'Bravo Booster' : 'Bravo Security'
    },
    download () {
      return this.app
        ? 'https://play.google.com/store/apps/details?id=com.bravo.booster&hl=en_SG&gl=US'
        : 'https://play.google.com/store/apps/details?id=com.topsecurity.android'
    }
  }
}
</script>
<style lang="less">
.container {
  min-width: 1280px;
}
.page-pc {
  min-height: 100%;
  background: url(../../assets/images/sfm-bg.png) no-repeat;
  background-position: center center;
  background-size: cover;
  padding: 10px 0.1px;
  .header {
    font-size: 0;
    display: flex;
    justify-content: space-around;
    margin-top: 23px;
    .logo-text {
      font-size: 0.2rem;
      margin: 0;
      color: #fff;
    }
    .logo {
      height: 30px;
      width: 237px;
      object-fit: contain;
    }
    .name {
      font-size: 20px;
      color: #fff;
    }
    .nav {
      .mail,
      .privacy,
      .terms {
        color: #fff;
        font-weight: 500;
        font-size: 14px;
        position: relative;
        z-index: 5;
      }
      .mail,
      .privacy {
        margin-right: 26.67px;
      }
    }
  }
  .main {
    font-size: 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    width: 100%;
    bottom: 200px;
    left: 50%;
    transform: translateX(-50%);
    line-height: 20px;
    .logo {
      width: 133px;
      margin-top: 172px;
      object-fit: contain;
    }
    .text {
      font-weight: bold;
      color: #fff;
      font-size: 50px;
      margin: 60px 0;
    }
    .desc {
      // max-width: 50%;
      margin: 58px 0 24px;
      font-family: HelveticaNeue;
      font-size: 20px;
      color: #ffffff;
      line-height: 0;
      // letter-spacing: 3.73px;
      text-align: center;
      // font-style: italic;
    }
    .downloads {
      margin-top: 30px;
      .appStore,
      .googlePlay {
        width: 144px;
        border-radius: 6px;
      }
      .appStore {
        margin-right: 26.67px;
      }
    }
  }
}
</style>
